<div class="tl-wrap">
  <span class="tl-top"
    >{{ title || "-" }}
    @if (infoTooltipKey) {
    <i
      class="fas fa-info-circle info-inline"
      [attr.title]="infoTooltipKey | translate"
    ></i>
    }
  </span>
  @if (subtitle) {
  <span class="tl-bottom">{{ subtitle }}</span>
  }
</div>
